/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Clear_FilterInputs */

const vi_common_clear_filter = /** @type {(inputs: Common_Clear_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá lọc`)
};

/**

* @param {Common_Clear_FilterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_clear_filter = /** @type {((inputs?: Common_Clear_FilterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Clear_FilterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_clear_filter(inputs)
});